import React, { useMemo, ReactNode, useEffect, useState } from 'react';

import { Menu } from 'antd';
import { Icon, TranslatedText, withComponent, useRouter, navigate, DrawerProvider } from '@sms/plasma-ui';

import app from '../../config/app.json';
// @ts-ignore
// import botao_download_grafana from '!!raw-loader!../../config/js/botao_download_grafana.js';
import botao_download_grafana_scroll from '!!raw-loader!../../config/js/botao_download_grafana_scroll.js';
import * as styled from './PageWithMenu.styles';
import { useSecurity } from '@sms/security-plasma-security-auth-sdk-react';

declare global {
  interface Window {
    __downloadCSVButtonInjected?: boolean;
  }
}


type PageWithMenuProps = {
  children: ReactNode;
};

function PageWithMenu(props: PageWithMenuProps) {
  const { children } = props;
  const { breadcrumb } = useRouter('breadcrumb');
  const [counter, setCounter] = useState(0);

  const permissions = Array.from(useSecurity().permissions);

  useEffect(() => {
    const intervalGrafana = setInterval(() => {
      const iframes = Array.from(document.getElementsByTagName('iframe')).filter(iframe => iframe.src.includes('/grafana')) || [];
      iframes.forEach(iframe => {
        try {
          const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
          if (!iframeDoc) {
            console.warn('Iframe do grafana não está pronto ainda, tentando novamente...');
            return;
          }
          if (iframeDoc.defaultView && iframeDoc.defaultView.__downloadCSVButtonInjected) {
            return;
          }
          const script = iframeDoc.createElement('script');
          if (script) {
            script.textContent = `window.__downloadCSVButtonInjected = true;\n${botao_download_grafana_scroll}`;
            iframeDoc.body.appendChild(script);
          }
        } catch (e) {
          console.warn('Erro ao acessar o iframe do grafana, tentando novamente...');
          setCounter(old => old + 1);
          if (counter > 10) {
            clearInterval(intervalGrafana);
          }
        }
      });
    }, 1000);
    return () => clearInterval(intervalGrafana);
  }, []);

  const title = useMemo(() => {
    const defaultSelectedKeys = breadcrumb.map((e) => e.route);
    return (
      <>
        <styled.Menu
          mode="horizontal"
          defaultSelectedKeys={defaultSelectedKeys}
          onClick={({ key }) => navigate(key)}
          style={{ fontSize: 16, fontWeight: 500, border: 0 }}
        >
          {permissions.includes('demandanalysis.view') ||
          permissions.includes('invoiceanalysis.view') ||
          permissions.includes('kpiregistration.view') ||
          permissions.includes('analyticaldashboards.view') ||
          permissions.includes('managementdashboards.view') ||
          permissions.includes('dashboard.view') ||
          permissions.includes('veroreport.view') ||
          permissions.includes('report.view') ||
          permissions.includes('dynamictable.view') ? (
            <Menu.SubMenu
              title={
                <>
                  <Icon name="chart-bar" prefix="far" />
                  Análises
                </>
              }
            >
              {permissions.includes('demandanalysis.view') && (
                <Menu.Item key={`/${app.code}/analises/analise-demanda`}>Análise de demanda</Menu.Item>
              )}
              {permissions.includes('invoiceanalysis.view') && (
                <Menu.Item key={`/${app.code}/contratos/contratos-fornecimento/analise-fatura`}>
                  Análise de fatura
                </Menu.Item>
              )}
              {permissions.includes('kpiregistration.view') ||
              permissions.includes('analyticaldashboards.view') ||
              permissions.includes('managementdashboards.view') ||
              permissions.includes('dashboard.view') ? (
                <Menu.SubMenu title="Painéis de controle">
                  {permissions.includes('kpiregistration.view') && (
                    <Menu.Item key={`/${app.code}/analises/paineis-controle/kpis`}>Cadastro de kpis</Menu.Item>
                  )}
                  {permissions.includes('analyticaldashboards.view') && (
                    <Menu.Item key={`/${app.code}/analises/paineis-controle/paineis-analiticos`}>
                      Painéis analíticos
                    </Menu.Item>
                  )}
                  {permissions.includes('managementdashboards.view') && (
                    <Menu.Item key={`/${app.code}/analises/paineis-controle/paineis-gerenciais`}>
                      Painéis gerenciais
                    </Menu.Item>
                  )}
                  {permissions.includes('dashboard.view') && (
                    <Menu.Item key={`/${app.code}/boards`}>
                      <TranslatedText textKey="app.menu.dashboards" />
                    </Menu.Item>
                  )}
                  {/* {
                    permissions.includes('dashteste.view') && (
                      <Menu.Item key={`/${app.code}/dashboard-admin`}>
                        Dashboards ADM
                      </Menu.Item>
                    )
                  } */}
                </Menu.SubMenu>
              ) : null}
              {permissions.includes('veroreport.view') ||
              permissions.includes('report.view') ||
              permissions.includes('dynamictable.view') ? (
                <Menu.SubMenu title="Relatórios">
                  {permissions.includes('veroreport.view') && (
                    <Menu.Item key={`/${app.code}/analises/relatorios/relatorios-1.0`}>Relatórios 1.0</Menu.Item>
                  )}
                  {permissions.includes('report.view') && (
                    <Menu.Item key={`/${app.code}/reports`}>Relatórios 2.0</Menu.Item>
                  )}
                  {permissions.includes('dynamictable.view') && (
                    <Menu.Item key={`/${app.code}/analises/relatorios/tabelas-dinamicas`}>Tabelas dinâmicas</Menu.Item>
                  )}
                </Menu.SubMenu>
              ) : null}
            </Menu.SubMenu>
          ) : null}

          {permissions.includes('freemarket.view') ||
          permissions.includes('freemarketmetering.view') ||
          permissions.includes('freemarketmigration.view') ||
          permissions.includes('distributedgeneration.view') ||
          permissions.includes('distributedgenerationmetering.view') ? (
            <Menu.SubMenu
              title={
                <>
                  <Icon name="solar-panel" prefix="far" />
                  Hub de energia
                </>
              }
            >
              {(permissions.includes('freemarket.view') ||
                permissions.includes('freemarketmetering.view') ||
                permissions.includes('freemarketmigration.view')) && (
                <Menu.SubMenu title="Mercado Livre">
                  {permissions.includes('freemarket.view') && (
                    <Menu.Item key={`/${app.code}/contratos/outros-contratos/mercado-livre`}>
                      Painel de mercado livre
                    </Menu.Item>
                  )}
                  {permissions.includes('freemarketmetering.view') && (
                    <Menu.Item key={`/${app.code}/contratos/outros-contratos/medicao-mercado-livre`}>
                      Medição de mercado livre
                    </Menu.Item>
                  )}
                  {permissions.includes('freemarketmigration.view') && (
                    <Menu.Item key={`/${app.code}/contratos/outros-contratos/migracoes-contratos-mercado-livre`}>
                      Migrações de contratos mercado livre
                    </Menu.Item>
                  )}
                </Menu.SubMenu>
              )}
              {(permissions.includes('distributedgeneration.view') ||
                permissions.includes('distributedgenerationmetering.view')) && (
                <Menu.SubMenu title="Geração Distribuída">
                  {permissions.includes('distributedgeneration.view') && (
                    <Menu.Item key={`/${app.code}/contratos/outros-contratos/geracao-distribuida`}>
                      Painel de geração distribuída
                    </Menu.Item>
                  )}
                  {permissions.includes('distributedgenerationmetering.view') && (
                    <Menu.Item key={`/${app.code}/contratos/outros-contratos/medicao-geracao-distribuida`}>
                      Medição de geração distribuída
                    </Menu.Item>
                  )}
                </Menu.SubMenu>
              )}
            </Menu.SubMenu>
          ) : null}

          {permissions.includes('measurementchart.view') || permissions.includes('manualinput.view') ? (
            <Menu.SubMenu
              title={
                <>
                  <Icon name="tachometer-alt" prefix="far" />
                  Painéis de medição
                </>
              }
            >
              {permissions.includes('measurementchart.view') && (
                <Menu.Item key={`/${app.code}/medicao/graficos-medicao`}>Gráficos de medição</Menu.Item>
              )}
              {permissions.includes('manualinput.view') && (
                <Menu.Item key={`/${app.code}/medicao/entrada-manual`}>Entrada manual</Menu.Item>
              )}
              {/* {permissions.includes('agentecharge.view') && (
                <Menu.Item key={`/${app.code}/medicao/recarga-agentes`}>
                  Recarga de agentes
                </Menu.Item>
              )} */}
            </Menu.SubMenu>
          ) : null}

          {permissions.includes('contractpart.view') || permissions.includes('contracttemplate.view') || permissions.includes('vendorcontract.view') || permissions.includes('contract.view') || permissions.includes('contractsimulation.view') ||
            permissions.includes('invoiceautomation.view') || permissions.includes('invoiceautomationdashboards.view') || permissions.includes('invoiceposting.view') || permissions.includes('paymentrelease.view') || permissions.includes('invoicesimulation.view') ? (
            <Menu.SubMenu title={<><Icon name='file-signature' prefix='far' />Contratos</>}>
              {permissions.includes('contractpart.view') && (
                <Menu.Item key={`/${app.code}/contratos/partes-contratuais`}>
                  Partes contratuais
                </Menu.Item>
              )}
              {permissions.includes('contracttemplate.view') || permissions.includes('vendorcontract.view') || permissions.includes('contract.view') || permissions.includes('contractsimulation.view') ? (
                <Menu.SubMenu title="Contratos de fornecimento">
                  {permissions.includes('contracttemplate.view') && (
                    <Menu.Item key={`/${app.code}/contratos/contratos-fornecimento/modelos-contratos`}>
                      Modelos de contratos
                    </Menu.Item>
                  )}
                  {permissions.includes('vendorcontract.view') && (
                    <Menu.Item key={`/${app.code}/contratos/contratos-fornecimento/contratos-fornecedor`}>
                      Contratos de fornecedor
                    </Menu.Item>
                  )}
                  {permissions.includes('contract.view') && (
                    <Menu.Item key={`/${app.code}/contratos/contratos-fornecimento/contratos`}>
                      Contratos
                    </Menu.Item>
                  )}
                  {permissions.includes('contractsimulation.view') && (
                    <Menu.Item key={`/${app.code}/contratos/contratos-fornecimento/simulacao-contrato`}>
                      Simulação de contrato
                    </Menu.Item>
                  )}
                </Menu.SubMenu>
              ) : null}

              {permissions.includes('invoiceautomation.view') || permissions.includes('invoiceautomationdashboards.view') || permissions.includes('invoiceposting.view') || permissions.includes('paymentrelease.view') || permissions.includes('invoicesimulation.view') ? (
                <Menu.SubMenu title="Contratos operacionais">
                  {permissions.includes('invoiceautomation.view') && (
                    <Menu.Item key={`/${app.code}/contratos/contratos-fornecimento/aprovacao-fatura`}>
                      Automação de faturas
                    </Menu.Item>
                  )}
                  {permissions.includes('invoiceautomationdashboard.view') && (
                    <Menu.Item key={`/${app.code}/contratos/contratos-fornecimento/resumo-processamento-fatura`}>
                      Painel de automação de faturas
                    </Menu.Item>
                  )}
                  {permissions.includes('invoiceposting.view') && (
                    <Menu.Item key={`/${app.code}/contratos/contratos-fornecimento/lancamento-fatura`}>
                      Lançamento de fatura
                    </Menu.Item>
                  )}
                  {permissions.includes('invoicequery.view') && (
                    <Menu.Item key={`/${app.code}/contratos/contratos-fornecimento/consulta-fatura`}>
                      Consulta de faturas
                    </Menu.Item>
                  )}
                  {permissions.includes('invoicesimulation.view') && (
                    <Menu.Item key={`/${app.code}/contratos/contratos-fornecimento/simulacao-fatura`}>
                      Simulação de fatura
                    </Menu.Item>
                  )}
                </Menu.SubMenu>
              ) : null}
            </Menu.SubMenu>
          ) : null}

          {permissions.includes('budgetversion.view') ||
          permissions.includes('tariffversion.view') ||
          permissions.includes('consumptionunitpercentage.view') ||
          permissions.includes('projectionanalysis.view') ||
          permissions.includes('versioncomparison.view') ||
          permissions.includes('budgetparameterization.view') ? (
            <Menu.SubMenu
              title={
                <>
                  <Icon name="usd-circle" prefix="far" />
                  Orçamento
                </>
              }
            >
              {permissions.includes('budgetversion.view') && (
                <Menu.Item key={`/${app.code}/orcamento/versoes-orcamento`}>Versões de orçamento</Menu.Item>
              )}
              {permissions.includes('tariffversion.view') ||
              permissions.includes('consumptionunitpercentage.view') ||
              permissions.includes('projectionanalysis.view') ||
              permissions.includes('versioncomparison.view') ? (
                <Menu.SubMenu title="Projeções tarifárias">
                  {permissions.includes('projectionanalysis.view') && (
                    <Menu.Item key={`/${app.code}/orcamento/projecoes-tarifarias/analise-projecao`}>
                      Análise de projeções
                    </Menu.Item>
                  )}
                  {permissions.includes('versioncomparison.view') && (
                    <Menu.Item key={`/${app.code}/orcamento/projecoes-tarifarias/comparativo-versoes`}>
                      Comparativo de versões
                    </Menu.Item>
                  )}
                  {permissions.includes('tariffversion.view') && (
                    <Menu.Item key={`/${app.code}/orcamento/projecoes-tarifarias/versoes-tarifarias`}>
                      Versões tarifárias
                    </Menu.Item>
                  )}
                  {permissions.includes('tariffcomposition.view') && (
                    <Menu.Item key={`/${app.code}/orcamento/projecoes-tarifarias/percentual-uso-uc`}>
                      Composição tarifária por distribuidora
                    </Menu.Item>
                  )}
                </Menu.SubMenu>
              ) : null}
              {permissions.includes('budgetparameterization.view') && (
                <Menu.Item key={`/${app.code}/orcamento/parametrizacoes`}>Parametrizações</Menu.Item>
              )}
            </Menu.SubMenu>
          ) : null}

          {permissions.includes('event.view') ||
          permissions.includes('task.view') ||
          permissions.includes('decision.view') ||
          permissions.includes('process.view') ||
          permissions.includes('rule.view') ? (
            <Menu.SubMenu
              title={
                <>
                  <Icon name="calendar-edit" prefix="far" />
                  Journal
                </>
              }
            >
              {permissions.includes('event.view') && (
                <Menu.Item key={`/${app.code}/events`}>
                  <TranslatedText textKey="app.menu.events" />
                </Menu.Item>
              )}
              {permissions.includes('task.view') && (
                <Menu.Item key={`/${app.code}/tasks`}>
                  <TranslatedText textKey="app.menu.tasks" />
                </Menu.Item>
              )}
              {permissions.includes('decision.view') && (
                <Menu.Item key={`/${app.code}/decisionTables`}>
                  <TranslatedText textKey="app.menu.decisionTables" />
                </Menu.Item>
              )}
              {permissions.includes('process.view') && (
                <Menu.Item key={`/${app.code}/processes`}>
                  <TranslatedText textKey="app.menu.processes" />
                </Menu.Item>
              )}
              {permissions.includes('forms.view') && (
                <Menu.Item key={`/${app.code}/forms`}>
                  <TranslatedText textKey="app.menu.forms" />
                </Menu.Item>
              )}
              {permissions.includes('rule.view') && (
                <Menu.Item key={`/${app.code}/rules`}>
                  <TranslatedText textKey="app.menu.rules" />
                </Menu.Item>
              )}
            </Menu.SubMenu>
          ) : null}

          {permissions.includes('addon.view') ||
          permissions.includes('parameter.view') ||
          permissions.includes('audittrail.view') ||
          permissions.includes('energyresource.view') ||
          permissions.includes('assettype.view') ||
          permissions.includes('assethierarchy.view') ||
          permissions.includes('logichierarchy.view') ||
          permissions.includes('userassignment.view') ||
          /* || permissions.includes('vendor.view') || permissions.includes('distributor.view') */ permissions.includes(
            'groupcompany.view',
          ) ||
          permissions.includes('verousers.view') ? (
            <Menu.SubMenu
              title={
                <>
                  <Icon name="cog" prefix="far" />
                  Configurações
                </>
              }
            >
              {permissions.includes('addon.view') ||
              permissions.includes('parameter.view') ||
              permissions.includes('audittrail.view') ||
              permissions.includes('energyresource.view') ? (
                <Menu.SubMenu title="Sistema">
                  {permissions.includes('addon.view') && (
                    <Menu.Item key={`/${app.code}/configuracoes/sistema/add-ons`}>Add-ons</Menu.Item>
                  )}
                  {permissions.includes('parameter.view') && (
                    <Menu.Item key={`/${app.code}/configuracoes/sistema/parametros`}>Parâmetros</Menu.Item>
                  )}
                  {permissions.includes('audittrail.view') && (
                    <Menu.SubMenu title="Auditoria">
                      <Menu.Item key={`/${app.code}/configuracoes/sistema/trilha-auditoria`}>
                        Trilha
                      </Menu.Item>
                      {permissions.includes('audittrail.edit') && (
                        <Menu.Item key={`/${app.code}/configuracoes/sistema/configuracoes-audit`}>
                          Configurações
                        </Menu.Item>
                      )}
                    </Menu.SubMenu>
                  )}

                  {permissions.includes('energyresource.view') && (
                    <Menu.Item key={`/${app.code}/configuracoes/sistema/insumos-energeticos`}>
                      Insumos energéticos
                    </Menu.Item>
                  )}
                </Menu.SubMenu>
              ) : null}

              {permissions.includes('assettype.view') ||
              permissions.includes('assethierarchy.view') ||
              permissions.includes('logichierarchy.view') ||
              permissions.includes('userassignment.view') ||
              permissions.includes('verousers.view') ? (
                <Menu.SubMenu title="Ativos">
                  {permissions.includes('assettype.view') && (
                    <Menu.Item key={`/${app.code}/configuracoes/ativos/tipos-ativos`}>
                      Tipos de ativos
                    </Menu.Item>
                  )}
                  {permissions.includes('assethierarchy.view') && (
                    <Menu.Item key={`/${app.code}/configuracoes/ativos/hierarquia-ativos`}>
                      Hierarquia de ativos
                    </Menu.Item>
                  )}
                  {permissions.includes('logichierarchy.view') && (
                    <Menu.Item key={`/${app.code}/configuracoes/ativos/organizacao-logica`}>
                      Organização lógica
                    </Menu.Item>
                  )}
                  {permissions.includes('userassignment.view') && (
                    <Menu.Item key={`/${app.code}/configuracoes/ativos/atribuicao-usuario`}>
                      Permissão da hierarquia
                    </Menu.Item>
                  )}
                  {permissions.includes('verousers.view') && (
                    <Menu.Item key={`/${app.code}/configuracoes/ativos/permissao-usuario`}>
                      Permissão de usuário (vero)
                    </Menu.Item>
                  )}
                </Menu.SubMenu>
              ) : null}

              {permissions.includes('groupcompany.view') && (
                <Menu.Item key={`/${app.code}/configuracoes/empresas-do-grupo`}>
                  Empresas do grupo
                </Menu.Item>
              )}

              {/* {permissions.includes('vendor.view') || permissions.includes('distributor.view') || permissions.includes('groupcompany.view') ? (
                <Menu.SubMenu title="Outras configurações">
                  {permissions.includes('vendor.view') && (
                    <Menu.Item key={`/${app.code}/configuracoes/outras-configuracoes/fornecedores`}>
                      Fornecedores
                    </Menu.Item>
                  )}
                  {permissions.includes('distributor.view') && (
                    <Menu.Item key={`/${app.code}/configuracoes/outras-configuracoes/distribuidores`}>
                      Distribuidores
                    </Menu.Item>
                  )}
                </Menu.SubMenu>
              ) : null} */}
            </Menu.SubMenu>
          ) : null}
        </styled.Menu>
      </>
    );
  }, [breadcrumb]);

  return (
    <DrawerProvider>
      {title}
      {children}
    </DrawerProvider>
  );
}

export default withComponent(PageWithMenu);
